import { clientRequestIdHeader } from '../models/Constants';
export function createRequestConfig(objectId, tenantId, application, currentPage, clientAppId, requestId, method) {
    var _a;
    if (method === void 0) { method = "GET" /* HttpRequestMethod.Get */; }
    var mailbox = "".concat(objectId, "@").concat(tenantId);
    var headers = (_a = {
            'X-AnchorMailbox': mailbox,
            'X-Office-Application': application.toString(),
            'X-Office-Scenario': currentPage,
            'X-RoutingParameter-SessionKey': objectId,
            'X-Ms-ClientAppId': clientAppId
        },
        _a[clientRequestIdHeader] = requestId,
        _a);
    return {
        headers: headers,
        method: method,
    };
}
//# sourceMappingURL=createRequestConfig.js.map